module.exports = __webpack_public_path__ + "img/localization.2659876f.png";